import { useQuery } from '@tanstack/react-query';

import { carbonSamplePlanConfigQueryOptions } from 'util/queryOptions';

import { useSamplePlanFormContext } from '../samplePlanFormContextV2';

export const useCarbonPlanConfigQuery = () => {
  const samplePlanForm = useSamplePlanFormContext();
  const samplePlanValues = samplePlanForm.getValues();
  const { isPending: isConfigPending, data: samplePlanConfig } = useQuery(
    carbonSamplePlanConfigQueryOptions(samplePlanValues.registry_list),
  );
  return { isConfigPending, samplePlanConfig };
};
